import { default as styledComponent } from 'styled-components';

/**
 * @param element html tag name to create
 * @returns styled components styled function
 */
export function styled<T1, T2>(
    element: any,
    styledComponentName: string,
    componentName?: string
) {
    const selector = `${componentName}-${styledComponentName}`;
    const StyledElement = styledComponent<T1, T2>(element).attrs({
        'data-selector': selector,
    });
    return StyledElement;
}



// WEBPACK FOOTER //
// ./src/utils/styled.ts